import React from 'react';
import { UserManagement } from '../components/shared/UserManagement';

export const Users: React.FC = () => {
  return (
    <div className="p-6">
      <UserManagement />
    </div>
  );
};
